import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationSandbox } from '@hohr/config';
import { of } from 'rxjs';
import { first, mergeMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AccessGuard implements CanActivate {
  constructor(
    private authSandbox: AuthenticationSandbox,
    private router: Router
  ) {}

  canActivate() {
    return this.authSandbox.authenticated$.pipe(
      first(),
      mergeMap((isAuth) => {
        if (!isAuth) {
          return of(true);
        }

        return this.router.navigate(['my-cvs']);
      })
    );
  }
}
